const ISTA_MECHANICAL_FAILURES = [
  'carryOutIstaVehicleTest',
  'istaCheckList.carryOutIstaVehicleTest',
];

export const isIstaDamageLine = (
  mechanicalFailure: string | null | undefined,
): boolean =>
  !!mechanicalFailure && ISTA_MECHANICAL_FAILURES.includes(mechanicalFailure);
